import { ProcedureRow } from "types/CreateOrder";

export type CptGroup = {
  cptCode: string;
  rows: ProcedureRow[];
  totalInCents: number;
  isBundle: boolean;
};

export function buildCptGroups(rows: ProcedureRow[]): CptGroup[] {
  const groups = new Map<string, CptGroup>();

  rows.forEach((row) => {
    const existing = groups.get(row.cptCode);

    if (existing) {
      existing.rows.push(row);
      existing.isBundle = true;
      return;
    }

    groups.set(row.cptCode, {
      cptCode: row.cptCode,
      rows: [row],
      totalInCents: 0,
      isBundle: false,
    });
  });

  return [...groups.values()].map((group) => ({
    ...group,
    totalInCents: group.rows.reduce((sum, row) => sum + (row.amount || 0), 0),
  }));
}
